import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["children", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, useContext, useLayoutEffect, useState } from 'react';
import { ModalStackContext } from './ModalManager';
function useScrollLockStyles(_ref) {
  var isLocked = _ref.isLocked;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    originalScrollPos = _useState2[0],
    setOriginalScrollPos = _useState2[1];
  useLayoutEffect(function () {
    if (isLocked && originalScrollPos === null) {
      // Store current scroll position
      setOriginalScrollPos(document.body.scrollTop || document.documentElement.scrollTop);
    } else if (originalScrollPos !== null) {
      // Restore original scroll position
      document.documentElement.scrollTop = document.body.scrollTop = originalScrollPos;
      setOriginalScrollPos(null);
    }
    // We only want the hook to run when `isLocked` changes,
    // adding `originalScrollPos` would cause an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLocked]);
  if (isLocked && originalScrollPos !== null) {
    return {
      position: 'fixed',
      top: "-".concat(originalScrollPos, "px"),
      width: '100%'
    };
  }
  return undefined;
}
var BodyScrollLock = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    style = props.style,
    otherProps = _objectWithoutProperties(props, _excluded);
  var modalStack = useContext(ModalStackContext);
  var hasModal = Boolean(modalStack === null || modalStack === void 0 ? void 0 : modalStack.length);
  var bodyLockStyles = useScrollLockStyles({
    isLocked: hasModal
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    style: style ? _objectSpread(_objectSpread({}, style), bodyLockStyles) : bodyLockStyles
  }, otherProps), children);
});
BodyScrollLock.displayName = 'BodyScrollLock';
export { BodyScrollLock, useScrollLockStyles };